import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  resetKey?: unknown
}
interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null })
    }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('UI-Fehler:', error, info)
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="card p-6 max-w-md text-center space-y-2">
            <p className="text-text-primary font-medium">Es ist ein Fehler aufgetreten</p>
            <p className="text-text-tertiary text-sm break-words">{this.state.error.message}</p>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
